import { render, staticRenderFns } from "./TemplateCertify.vue?vue&type=template&id=0c883806&scoped=true"
import script from "./TemplateCertify.vue?vue&type=script&lang=js"
export * from "./TemplateCertify.vue?vue&type=script&lang=js"
import style0 from "./TemplateCertify.vue?vue&type=style&index=0&id=0c883806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c883806",
  null
  
)

export default component.exports